import service from "@/utils/request";

export interface Record {
    record_id: number,
    name: string,
    node_id: number,
    current_process: number
}

export async function getUserRecord(gameId: number): Promise<Record> {
  const res = await service.get(`/api/records`, {params: {game_id: gameId}})
  return res.data
}


export async function delUserRecord(record: number): Promise<any> {
  const res = await service.delete(`/api/records/${record}`)
  return res.data
}

export interface RecordDetail {
  record_info: {
    record_id: number;
    name: string;
    user_id: number;
    game_id: number;
    node_id: number;
    max_chapter: number;
    node_status: number;
    create_time: string;
    update_time: string;
    current_node_info: {
      id: number;
      title: string;
    } | null;
    current_chapter_info: {
      id: number;
      title: string;
    } | null;
    max_chapter_info: {
      id: number;
      title: string;
    } | null;
    is_finished: boolean;
  };
  affections: any[];
  achievements: any[];
  items: any[];
  easter_eggs: any[];
  events: any[];
  statistics: {
    total_affections: number;
    total_achievements: number;
    total_items: number;
    unique_items: number;
    total_easter_eggs: number;
    total_events: number;
  };
}

export async function getRecordDetail(recordId: number, gameId: number): Promise<RecordDetail> {
  const res = await service.get(`/api/records/${recordId}/detail`, {params: {game_id: gameId}})
  return res.data.data
}